import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import { toast } from "react-toastify";

import { PdsrEditItem } from "../PdsrEditItem";
import { pdsrUrls } from "../../../../URL/ApplicationUrls";
import { updateSuccessMessage } from "../../../../Messages/successMessages";
import { MdmApiError } from "../../../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../../../Errors/apiErrorNotificationToast";

export const useUpdatePdsr = (pdsrId: string | undefined) => {
  return useMutation({
    mutationFn: async (pdsr: PdsrEditItem) => {
      await axios.put(pdsrUrls.pdsrWithId(pdsrId), { Comment: pdsr.Comment });
    },
    onSuccess: async () => {
      toast.success(updateSuccessMessage(pdsrId, "PDSR"));
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
